<template>
  <el-table
    ref="sysBoxTable"
    :data="tableList"
    :row-key="rowKey"
    :height="tableHeight"
    default-expand-all
    highlight-current-row
    :header-cell-style="getHeaderCellStyle"
    :cell-style="getCellStyle"
    @row-click="handlerRowClick"
    @selection-change="handleSelectionChange"
  >
    <el-table-column
      :reserve-selection="true"
      type="selection"
      width="55"
    ></el-table-column>
    <el-table-column
      type="index"
      width="55"
      label="序号"
      align="center"
      v-if="showIndex"
    ></el-table-column>
    <el-table-column
      v-for="(colum, index) in columList"
      :key="index"
      :formatter="formatterColumn"
      :prop="colum.prop"
      :label="colum.lable"
      :width="colum.width"
      :align="colum.align"
      :type="colum.type"
    >
    </el-table-column>
    <el-table-column
      label="操作"
      align="center"
      :width="operationWidth"
      v-if="showOperation"
    >
      <template slot-scope="scope">
        <slot name="slotButton" :rowData="scope.row" class="slotButton" />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  data() {
    return {
      multipleSelection: []
    };
  },
  props: {
    //操作栏宽度
    operationWidth: {
      type: String,
      default: "300px"
    },
    //是否显示序号
    showIndex: {
      type: Boolean,
      default: true
    },
    //table数据
    tableList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    //table主键
    rowKey: {
      type: String,
      default: "id"
    },
    //列表字段
    columList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    //默认选中参数
    multipleSelectionData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    //列表高度
    tableHeight: {
      type: String,
      default: null
    },
    //是否展示操作栏
    showOperation: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    multipleSelectionData(newVal, oldVal) {
      this.setRowSelection(this.multipleSelectionData);
    }
  },
  methods: {
    getCellStyle: function({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 1) {
        return "height: 50px;background: #f8fcff;opacity: 1;padding: 0;";
      } else {
        return "height: 50px;background: #fff;opacity: 1;padding: 0;";
      }
    },
    getHeaderCellStyle: function({ row, column, rowIndex, columnIndex }) {
      if (row.length - 1 === columnIndex) {
        return "height:60px;opacity: 1;background: #8fcbff;color: #333333;border-radius: 0px 4px 0px 0px;";
      }
      if (columnIndex === 0) {
        return "height:60px;opacity: 1;background: #8fcbff;color: #333333;border-radius: 4px 0px 0px 0px;";
      }
      return "height:60px;background: #8fcbff;color: #333333;opacity: 1;";
    },
    handleSelectionChange: function(val) {
      this.multipleSelection = val;
      this.$emit("handleSelectionChange", this.multipleSelection);
    },
    setRowSelection: function(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.sysBoxTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.sysBoxTable.clearSelection();
      }
    },
    handleClearSelection: function() {
      console.log("执行了=================");
      this.$refs.sysBoxTable.clearSelection();
    },
    formatterColumn: function(row, column) {
      if (column.type == "date") {
        let dateTime = row[column.property];
        return dateTime ? this.$moment(dateTime).format("YYYY-MM-DD") : "";
      } else {
        return row[column.property];
      }
    },
    handlerRowClick: function(row, column, event) {
      this.$refs.sysBoxTable.toggleRowSelection(row);
    }
  }
};
</script>

<style lang="scss" scoped></style>
